import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import OfficialDiaryAppService from '../../../../application/platform/sdp/official-diary/official-diary-app-service';
import { ACTION_TYPES, useOfficialDiaryDetailDispatch } from "./official-diary-detail-context";
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useOfficialDiaryDetailController = () => {
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = useOfficialDiaryDetailDispatch();
    const { officialDailyId } = useParams();

    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        try {
            showLoading({ open: true });
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });

            const data = await OfficialDiaryAppService.getById(Number(officialDailyId));
            dispatch({
                type: ACTION_TYPES.setOfficialDiaryDetail,
                payload: data
            });

            const file = await OfficialDiaryAppService.downloadFile(Number(officialDailyId));
            dispatch({
                type: ACTION_TYPES.setOfficialDiaryFile,
                payload: file
            });

            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os detalhes do diário oficial',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        }
    }

    return {
        loadData
    };
}
